var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { css, html, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";
let RrFrequencyInput = class RrFrequencyInput extends LitElement {
    constructor() {
        super(...arguments);
        this.min = 0;
        this.frequency = 0;
        this._scale = 1;
        this.step = 1;
    }
    get scale() {
        return this._scale;
    }
    set scale(scale) {
        if (scale != 1 && scale != 1000 && scale != 1000000)
            return;
        let oldScale = this._scale;
        this._scale = scale;
        this.requestUpdate("scale", oldScale);
    }
    static get styles() {
        return [
            css `
        input {
          width: 13ex;
        }

        @media (prefers-color-scheme: dark) {
          input,
          select {
            background: #222;
            color: #ddd;
          }
        }
      `,
        ];
    }
    render() {
        return html `<input
        type="number"
        id="frequency"
        .step=${String(this.step / this.scale)}
        .value=${String(this.frequency / this.scale)}
        @change=${this.onFrequencyChange}
      /><select id="scale" @change=${this.onScaleChange}>
        <option value="1" .selected=${this.scale == 1}>Hz</option>
        <option value="1000" .selected=${this.scale == 1000}>kHz</option>
        <option value="1000000" .selected=${this.scale == 1000000}>MHz</option>
      </select>`;
    }
    onFrequencyChange(e) {
        let input = e.target;
        let value = Number(input.value);
        if (!isNaN(value)) {
            let frequency = value * this.scale;
            if (frequency >= this.min &&
                (this.max === undefined || frequency <= this.max)) {
                this.frequency = value * this.scale;
                this.dispatchEvent(new Event("change"));
                return;
            }
        }
        input.value = String(this.frequency / this.scale);
    }
    onScaleChange(e) {
        let select = e.target;
        let value = Number(select.selectedOptions[0].value);
        this.scale = value;
        this.dispatchEvent(new Event("scale-change"));
    }
};
__decorate([
    property({ type: Number, reflect: true }),
    __metadata("design:type", Number)
], RrFrequencyInput.prototype, "min", void 0);
__decorate([
    property({ type: Number, reflect: true }),
    __metadata("design:type", Number)
], RrFrequencyInput.prototype, "max", void 0);
__decorate([
    property({ type: Number, reflect: true }),
    __metadata("design:type", Number)
], RrFrequencyInput.prototype, "frequency", void 0);
__decorate([
    property({ type: Number, reflect: true }),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], RrFrequencyInput.prototype, "scale", null);
__decorate([
    property({ type: Number, reflect: true }),
    __metadata("design:type", Number)
], RrFrequencyInput.prototype, "step", void 0);
RrFrequencyInput = __decorate([
    customElement("rr-frequency-input")
], RrFrequencyInput);
export { RrFrequencyInput };
